export default "__VITE_ASSET__7721dd37__"